import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/Raleway-Bold/Raleway-Bold.ttf";
import "./assets/fonts/Raleway-Regular/Raleway-Regular.ttf";

import "./assets/fonts/Roboto-Bold/Roboto-Bold.ttf";

import "./assets/fonts/Roboto-Regular/Roboto-Regular.ttf";

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
